module.exports = __webpack_public_path__ + "static/media/18ECA9.d3818cd3.jpg";